module.exports = __webpack_public_path__ + "static/media/development.8fd580df.jpg";